import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getReportProject as getReportProjectApi } from "../../helpers/fakebackend_helper";
import { vendorInvoiceAPI } from "../../helpers/api/vendorInvoice";

export const getReportProject = createAsyncThunk(
  "getReportProject",
  async (id) => {
    try {
      return await getReportProjectApi(id);
    } catch (error) {
      toast.error("Failed to fetch project report", { autoClose: 3000 });
      throw error;
    }
  }
);

export const fetchCostReport = createAsyncThunk(
  "report/fetchCostReport",
  async ({ projectId, phaseId = null }, { rejectWithValue }) => {
    try {
      return await vendorInvoiceAPI.getCostReport(projectId, phaseId);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch cost report");
    }
  }
);

export const fetchBlockReport = createAsyncThunk(
  "report/fetchBlockReport",
  async ({ projectId, phaseId, blockId }, { rejectWithValue }) => {
    try {
      return await vendorInvoiceAPI.getCostReport(projectId, phaseId, blockId);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch block report");
    }
  }
);

export const fetchCostSummary = createAsyncThunk(
  "report/fetchCostSummary",
  async (phaseId = null, { rejectWithValue }) => {
    try {
      return await vendorInvoiceAPI.getCostSummary(phaseId);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch cost summary");
    }
  }
);
